import React, { useEffect, useMemo, useRef, useState } from "react";
import JoditEditor from "jodit-react";
import useFullPageLoader from "../../../hooks/useFullPageLoader";
import useButtonLoader from "../../../hooks/UseButtonLoader";
import toast from "react-hot-toast";
import { getCmsDetailApi, updateCmsApi } from "../../../services/cms";
import {
  Input,
  TextArea,
  dateFormat,
  dateTime,
} from "../../../components/Form";
import ModalBox from "../../../components/modal/ModalBox";
const Editor = ({ title, type, contentType }) => {
  const [error, setError] = useState({ data: "" });
  const [cmsData, setCmsData] = useState({});
  const [statusModal, setStatusModal] = useState(false);
  const [data, setData] = useState("");
  const [buttonref, buttonLoader] = useButtonLoader("Update");
  const [loader, showLoader, hideLoader] = useFullPageLoader();
  const editor = useRef(null);
  const [url, setUrl] = useState({ url: "" });
  // console.log("url", url)
  // console.log('cmsData', cmsData)
  const onChange = (e) => {
    const { name, value } = e.target;
    setUrl({ ...url, [name]: value });
  };
  const config = useMemo(
    () => ({
      readonly: false,
      toolbar: true,
      spellcheck: true,
      language: "en",
      toolbarButtonSize: "medium",
      showCharsCounter: true,
      showWordsCounter: true,
      showXPathInStatusbar: false,
      askBeforePasteHTML: false,
      askBeforePasteFromWord: false,
      uploader: {
        insertImageAsBase64URI: true,
      },
      controls: {
        font: {
          command: "fontname",
          list: {
            "'Open Sans',sans-serif": "Open Sans",
            "Helvetica,sans-serif": "Helvetica",
            "Arial,Helvetica,sans-serif": "Arial",
            "Georgia,serif": "Georgia",
            "Impact,Charcoal,sans-serif": "Impact",
            "Tahoma,Geneva,sans-serif": "Tahoma",
            "'Times New Roman',Times,serif": "Times New Roman",
            "Verdana,Geneva,sans-serif": "Verdana",
            "Consolas,monaco,monospace": "Consolas",
          },
        },
      },
    }),
    []
  );
  //---------validation-----------------------
  const validation = () => {
    let errorMessage = {};
    const strippedContent = cmsData.data.replace(/(<([^>]+)>)/gi, ""); // Remove HTML tags

    let status = true;
    if (!cmsData.data || cmsData.data === "<p><br></p>") {
      errorMessage["data"] = "please enter description";
      status = false;
    } else if (type === "powerful text" && strippedContent.length > 150) {
      errorMessage["data"] = "Content exceeds the 150 character limit.";
      status = false;
    }
    if (type === "highlight") {
      if (!url.url) {
        errorMessage["url"] = "please enter Url";
        status = false;
      }
    }
    setError(errorMessage);
    return status;
  };
  console.log(error, "erro");
  //---------on-Change-----------------------
  // const onChangeHandler = (value) => {
  //   setCmsData({ ...cmsData, data: value });
  // };
  const onChangeHandler = (value, type) => {
    const maxCharacters = 150;

    // Apply the character limit only if the type is "powerfulText"
    if (type === "powerful text") {
      if (value.length <= maxCharacters) {
        setCmsData({ ...cmsData, data: value });
        setError({
          data: "limit",
        });
      }
    } else {
      setCmsData({ ...cmsData, data: value });
    }
  };

  //*********************GET CMS DATA********************************** */
  const getCmsDetails = async (
    normalType = type,
    categoryType = contentType
  ) => {
    try {
      showLoader();
      const res = await getCmsDetailApi({ type: normalType, categoryType });
      if (res.data?.status === 200) {
        // console.log("cmsRes", res?.data?.data?.Content?.url)
        setCmsData({
          ...cmsData,
          data: res?.data?.data?.Content?.description || "",
        });

        setData(res?.data?.data?.Content?.updatedAt);
        setUrl({ url: res?.data?.data?.Content?.url });
        hideLoader();
      } else {
        setCmsData({ data: "" });
        hideLoader();
      }
    } catch (err) {
      toast.error(err?.message);
    }
  };

  //*********************update cms handler********************************** */
  const updateCmsHandler = async (e) => {
    e.preventDefault();
    // if (validation()) {
    const finalObj = {
      type: type,
      categoryType: contentType,
      description: cmsData.data,
    };
    if (type === "highlight") {
      finalObj.url = url?.url;
    }
    try {
      buttonLoader(true);
      const res = await updateCmsApi(finalObj);
      if (res?.data?.status === 200) {
        setStatusModal(false);
        toast.success(res.data.message);
        getCmsDetails(type, contentType);
        buttonLoader(false);
      } else {
        toast.error(res.data.message);
        buttonLoader(false);
      }
    } catch (err) {
      toast.error(err?.message);
      buttonLoader(false);
    }
    // }
  };

  useEffect(() => {
    getCmsDetails(type, contentType);
    setError({ data: "" });
  }, [type, contentType]);

  return (
    <div>
      {loader}
      <h4 className="text-center text-dark mb-4 mt-4">{title}</h4>
      <div className="text-end text-dark mb-4 mt-4">
        <h6>{dateTime(data)}</h6>
      </div>
      <JoditEditor
        ref={editor}
        value={cmsData.data}
        tabIndex={1}
        onBlur={onChangeHandler}
        config={config}
        // maxLength={40}
      />
      {error.data && (
        <p
          className={`invalid-feedback ${
            (!cmsData.data ||
              cmsData.data === "<p><br></p>" ||
              error.data === "Content exceeds the 120 character limit.") &&
            "d-block"
          }`}
        >
          {error.data}
        </p>
      )}
      {type === "highlight" && (
        <div className="mt-2">
          <TextArea
            label={"URL"}
            type="text"
            name="url"
            value={url?.url || ""}
            onChange={onChange}
            placeholder="Enter url"
            className={`form-control `}
            error={error.url}
            maxLength={120}
          />
        </div>
      )}
      <div className="text-center mt-4">
        <button
          className="btn_size"
          onClick={() => {
            if (validation()) {
              setStatusModal(true);
            }
          }}

          // ref={buttonref}
        >
          Update
        </button>
      </div>
      <ModalBox
        status={statusModal}
        onClose={() => setStatusModal(false)}
        title={`Update ${
          contentType === "powerful text"
            ? "Powerful Text"
            : "Content Management"
        } `}
        description={<span>Do you want to Update this content ?</span>}
        action={updateCmsHandler}
        // ref={buttonref}
      />
    </div>
  );
};

export default Editor;
